import { z } from 'zod';

export const ProdutoVendaExternaEstoqueSchema = z.object({
    vet_idpk: z.number(),
    vet_nome: z.string().nullable(),
    vet_produto_idpk: z.number().nullable(),
    vet_qtde_bonificada: z.number(),
    vet_qtde_devolvida: z.number(),
    vet_qtde_disponivel: z.number(),
    vet_qtde_remessa: z.number(),
    vet_qtde_vendida: z.number(),
    vet_regra_fiscal_idpk: z.number().nullable(),
    vet_ultima_alteracao: z.string(),
    vet_unidade_sigla: z.string(),
    vet_valor_unitario: z.number(),
    vet_venda_externa_idpk: z.number(),
});
